const PromoVideoSection = () => {
  return (
    <section className="py-16 overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="mx-auto max-w-4xl">
          <div className="relative rounded-2xl overflow-hidden border border-border bg-card shadow-[0_0_60px_rgba(255,215,0,0.08)]">
            <video
              autoPlay
              loop
              controls
              playsInline
              className="w-full h-auto"
            >
              <source src="/videos/promo.mov" type="video/quicktime" />
              <source src="/videos/promo.mov" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PromoVideoSection;
